import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { whatsappLink } from '../data/mock';
import { WhatsAppIcon } from './WhatsAppIcon';

const navItems = [
  { id: 'home', label: 'Início' },
  { id: 'benches', label: 'Bancadas' },
  { id: 'services', label: 'Serviços' },
  { id: 'about', label: 'Sobre' },
  { id: 'reviews', label: 'Avaliações' },
  { id: 'faq', label: 'Dúvidas' }
];

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setOpen(false);
  };

  const ctaClass = "bg-[#25D366] text-white px-5 py-2.5 rounded-md hover:bg-[#1fb857] transition-all duration-300 font-semibold flex items-center justify-center gap-2";

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || open ? 'bg-[#0a0a0a]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          <button onClick={() => scrollToSection('home')} data-testid="header-logo" className="flex items-center gap-3 group">
            <img
              src="/logo-nova.png"
              alt="O.C. GOMES - Sistema de Injeção Diesel"
              className="h-14 md:h-20 w-14 md:w-20 rounded-full object-contain drop-shadow-[0_0_12px_rgba(255,107,0,0.35)] group-hover:drop-shadow-[0_0_18px_rgba(255,107,0,0.6)] transition-all duration-300"
            />
            <div className="hidden sm:flex flex-col items-start leading-tight">
              <span className="text-white font-bold text-xl md:text-2xl tracking-wide">O.C. GOMES</span>
              <span className="text-[#FF6B00] text-[10px] md:text-xs font-semibold uppercase tracking-[0.2em]">Sistema de Injeção Diesel</span>
            </div>
          </button>

          <nav className="hidden lg:flex items-center space-x-7">
            {navItems.map((n) => (
              <button key={n.id} onClick={() => scrollToSection(n.id)} data-testid={`nav-${n.id}`} className="text-white hover:text-[#FF6B00] transition-colors duration-300 font-medium">
                {n.label}
              </button>
            ))}
            <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" data-testid="nav-whatsapp-cta" className={ctaClass}>
              <WhatsAppIcon className="w-5 h-5" />
              Orçamento no WhatsApp
            </a>
          </nav>

          <button className="lg:hidden text-white p-2" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="mobile-menu-button">
            {open ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {open && (
          <nav className="lg:hidden mt-4 pb-4 space-y-1" data-testid="mobile-menu">
            {navItems.map((n) => (
              <button key={n.id} onClick={() => scrollToSection(n.id)} data-testid={`nav-${n.id}-mobile`} className="block w-full text-left text-white hover:text-[#FF6B00] transition-colors duration-300 font-medium py-3 text-lg">
                {n.label}
              </button>
            ))}
            <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" data-testid="nav-whatsapp-cta-mobile" className={`${ctaClass} w-full py-4 text-lg mt-2`}>
              <WhatsAppIcon className="w-6 h-6" />
              Orçamento no WhatsApp
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
